var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5,34.6L2,32.8l9.4-15l6,7l8-12.9l5.5,8.1c-0.5,0.1-1,0.2-1.6,0.3c-0.5,0.1-1,0.3-1.5,0.5l-2.2-3.5l-7.6,12.5l-6.1-7.1L4.5,34.6L4.5,34.6z M43.8,45l-6.7-6.7c-0.7,0.5-1.4,0.9-2.2,1.1c-0.8,0.3-1.7,0.4-2.5,0.4c-4.7,0-8.5-3.8-8.5-8.4c0,0,0,0,0,0c0-4.7,3.8-8.5,8.5-8.5c0,0,0,0,0.1,0c4.7,0,8.5,3.8,8.5,8.5c0,0,0,0,0,0.1c0,0.9-0.1,1.7-0.4,2.5c-0.3,0.8-0.7,1.6-1.1,2.3l6.7,6.6L43.8,45L43.8,45z M32.3,36.9c3.1,0,5.5-2.5,5.5-5.5c0-1.5-0.6-2.9-1.6-3.9c-2.2-2.2-5.7-2.2-7.8,0s-2.2,5.6,0,7.8C29.5,36.3,30.9,36.9,32.3,36.9L32.3,36.9z M36.1,20.5c-0.5-0.2-1-0.4-1.5-0.4l-1.7-0.2L43.6,3L46,4.8L36.1,20.5L36.1,20.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimization);
export default __webpack_public_path__ + "static/media/optimization.88aaae9819e76b687bfdc01db09c5886.svg";
export { ForwardRef as ReactComponent };